<ng-container *ngIf="ato">
    <div class="titulo-pagina">{{ tipoEdicao.titulo }}</div>
    <div id="invisivel" class="invisivel" tabindex="0"></div>
    <div id="atoARepublicarLb" *ngIf="textoAtoARepublicar" style="margin-bottom: 10px;">
        <span style="font-weight: bold;">{{ textoAtoARepublicar }}</span>
        <span *ngIf="altObservacaoAtoRepublicacao" 
            style="color: red; font-weight: bold; cursor: pointer;" 
            title="{{ altObservacaoAtoRepublicacao }}">(*)</span>
    </div>
    <form #form="ngForm">
        <div class="row">
            <div class="col-sm-8">
                <suite-rfb-select label="Tipo do ato" name="tipoAto" [labels]="labelsTipoAto" [values]="tiposAto"
                    [(ngModel)]="ato.tipoAto" [required]="true" [clearable]="false" [disabled]="readonly" (ngModelChange)="verificarAtosDuplicados()">
                </suite-rfb-select>
            </div>
            <div class="col-sm-2">
                <div class="form-group" [suiteRfbHasError]="numeroAtoCtrl">
                    <label for="numeroAto" class="control-label obrigatorio">Número do ato</label>
                    <input #numeroAtoCtrl="ngModel" type="text" name="numeroAto" class="form-control" [(ngModel)]="ato.numeroAto" 
                    [required]="true" maxlength="20" [disabled]="readonly" (change)="verificarAtosDuplicados()">
                    <suite-rfb-local-messages [control]="numeroAtoCtrl"></suite-rfb-local-messages>
                </div>
            </div>
            <div class="col-sm-2">
                <suite-rfb-date-picker label="Data do ato" name="dataAto" [required]="true" [(ngModel)]="ato.dataAto"
                    [outsideClick]="true" [disabled]="readonly" (ngModelChange)="verificarAtosDuplicados()"></suite-rfb-date-picker>
            </div>
        </div>
        
        <div class="row">
            <div class="col-sm-8">
                <suite-rfb-select label="Órgãos / unidades" name="orgaos" [labels]="labelsOrgao" [values]="orgaos"
                    [multiple]="true" [maxSelectedItems]="100" [(ngModel)]="orgaosSelecionados" [required]="true"
                    [compareWith]="compareOrgaos" [disabled]="readonly" (ngModelChange)="verificarAtosDuplicados()">
                </suite-rfb-select>
            </div>
            <div class="col-sm-4">
                <div *ngIf="atosDuplicados && atosDuplicados.length > 0" class="alert alert-warning ng-star-inserted">
                    <div class="alert-icone" style="margin-right: 24px;">
                        <span class="material-icons icon-48 ng-star-inserted"></span>
                    </div>
                    <div class="alert-mensagem">
                        <div>{{ textoAlertaDuplicidade }}</div>
                        <div>
                            <span (click)="rolarParaTabelaAtosDuplicados()" style="color: #039; text-decoration: none; cursor: pointer;">Veja e compare para prosseguir.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-2">
                <suite-rfb-date-picker label="Data da publicação" name="dataPublicacao" [required]="true"
                    [(ngModel)]="ato.dataPublicacao" [outsideClick]="true" [disabled]="readonly"></suite-rfb-date-picker>
            </div>
            <div class="col-sm-6">
                <label class="control-label">Local da publicação</label>
                <div>
                    <input type="radio" name="local" value="1" (change)="onChangeLocal($event)"
                        [checked]="ato.idLocalPublicacao === 1 ? 'checked' : null" [disabled]="readonly">
                    <label class="control-label">&nbsp;DOU</label>&nbsp;&nbsp;&nbsp;&nbsp;
                    <input type="radio" name="local" value="2" (change)="onChangeLocal($event)"
                        [checked]="ato.idLocalPublicacao === 2 ? 'checked' : null" [disabled]="readonly">
                    <label class="control-label">&nbsp;BP/MF</label>&nbsp;&nbsp;&nbsp;&nbsp;
                    <input type="radio" name="local" value="3" (change)="onChangeLocal($event)"
                        [checked]="ato.idLocalPublicacao === 3 ? 'checked' : null" [disabled]="readonly">
                    <label class="control-label">&nbsp;BS/RFB</label>&nbsp;&nbsp;&nbsp;&nbsp;
                    <input type="radio" name="local" value="4" (change)="onChangeLocal($event)"
                        [checked]="ato.idLocalPublicacao === 4 ? 'checked' : null" [disabled]="readonly">
                    <label class="control-label">&nbsp;Outro&nbsp;
                        <input type="text" *ngIf="ato.idLocalPublicacao === 4"
                            name="localPublicacao" [(ngModel)]="ato.textoLivre" [required]="true" maxlength="20000" style="width: 500px" [disabled]="readonly">
                    </label>
                </div>
            </div>
            <div class="col-sm-2" *ngIf="ato.idLocalPublicacao === 1 || ato.idLocalPublicacao === 3">
                <label for="secao" class="control-label">Seção</label>
                <input type="text" name="secao" class="form-control" [(ngModel)]="ato.secao" [disabled]="readonly">
            </div>
            <div class="col-sm-2" *ngIf="ato.idLocalPublicacao === 1 || ato.idLocalPublicacao === 3">
                <label for="pagina" class="control-label">Página</label>
                <input type="text" name="pagina" class="form-control" [(ngModel)]="ato.numeroPagina" maxlength="6"
                    suiteRfbNumbersOnly [disabled]="readonly">
            </div>
        </div>

        <div class="row">
            <div class="col-sm-4">
                <label class="control-label">Liberação para consulta</label>
                <div>
                    <input type="radio" name="publicado" value="Publicado" (change)="onChangePublicado($event)"
                        [checked]="ato.publicado ? 'checked' : null" [disabled]="readonly">
                    <label class="control-label">&nbsp;Liberar</label>&nbsp;&nbsp;&nbsp;&nbsp;
                    <input type="radio" name="publicado" value="Não liberar" (change)="onChangePublicado($event)"
                        [checked]="ato.publicado ? null : 'checked'" [disabled]="readonly">
                    <label class="control-label">&nbsp;Não liberar</label>
                </div>
            </div>
            <div class="col-md-2" *ngIf="!tipoEdicao.isCorrecaoAto()">
                &nbsp;
            </div>

            <div class="col-sm-2">
                <suite-rfb-date-picker label="Vigência" name="vigenciaInicial" [(ngModel)]="ato.dataVigenciaInicio"
                    [outsideClick]="true" [disabled]="readonly"></suite-rfb-date-picker>
            </div>
            <div class="col-sm-2">
                <suite-rfb-date-picker label="a" name="vigenciaFinal" [(ngModel)]="ato.dataVigenciaFim"
                    [outsideClick]="true" [disabled]="readonly"></suite-rfb-date-picker>
            </div>
            <div class="col-md-2 caixa-exibicao-internet">
                <label class="control-label" style="color:white;">Exibição na internet</label>
                <div class="checkbox">
                    <label>
                        <input type="checkbox" name="exibicao_internet" (change)="onChangeInternet($event)"
                            [checked]="ato.internet ? 'checked' : null"  [disabled]="readonly">
                        Permitir
                    </label>
                </div>
            </div>
            <div class="col-md-2" *ngIf="!tipoEdicao.isCorrecaoAto()">
                &nbsp;
            </div>

            <div class="col-md-2" *ngIf="tipoEdicao.isCorrecaoAto()">
                <label class="control-label">Exibição no SIJUT-1</label>
                <div class="checkbox">
                    <label>
                        <input type="checkbox" name="exibicao_internet" (change)="onChangeExibicaoSijut($event)"
                            [checked]="ato.flags === '1' ? 'checked' : null" [disabled]="readonly">
                        Permitir
                    </label>
                </div>
            </div>

        </div>

        <div class="row">
            <div class="col-sm-5">
                <label class="control-label">Visões</label>
                <div>
                    <input type="checkbox" (change)="onChangeVisao($event, 0)"
                        [checked]="ato.exibirVisoes.charAt(0) === '1' ? 'checked' : null" value="0" [disabled]="readonly">
                    <label class="control-label">&nbsp;Original</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <input type="checkbox" (change)="onChangeVisao($event, 1)"
                        [checked]="ato.exibirVisoes.charAt(1) === '1' ? 'checked' : null" value="1" [disabled]="readonly">
                    <label class="control-label">&nbsp;Multivigente</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <input type="checkbox" (change)="onChangeVisao($event, 2)"
                        [checked]="ato.exibirVisoes.charAt(2) === '1' ? 'checked' : null" value="2" [disabled]="readonly">
                    <label class="control-label">&nbsp;Vigente</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <input type="checkbox" (change)="onChangeVisao($event, 3)"
                        [checked]="ato.exibirVisoes.charAt(3) === '1' ? 'checked' : null" value="3" [disabled]="readonly">
                    <label class="control-label">&nbsp;Relacional</label>
                </div>
            </div>

            <div class="col-sm-7">
                <suite-rfb-select label="Assunto" name="assunto" [labels]="labelsAssunto" [values]="assuntos"
                    [(ngModel)]="assunto" [clearable]="false" [disabled]="readonly" (click)="onClickAssunto($event)">
                </suite-rfb-select>
            </div>
        </div>

        <div class="row" *ngIf="tipoEdicao.isCorrecaoAto()">
            <div class="col-sm-6">
                <suite-rfb-select label="Área responsável" name="orgaoResponsavel" [labels]="labelsOrgao" [values]="orgaos"
                    [(ngModel)]="ato.orgaoResponsavel" [compareWith]="compareOrgaos">
                </suite-rfb-select>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <span class="material-icons collapse-icon icone-colapse" *ngIf="!visualizarObservacoes"
                    (click)="exibirObservacoes()"> </span>
                <span class="material-icons collapse-icon icone-colapse" *ngIf="visualizarObservacoes"
                    (click)="inibirObservacoes()"> </span>
                <label for="observacao" class="control-label">Observações do ato</label>
                <textarea class="form-control" name="observacao" rows="5" maxlength="1200" cols="100"
                    [(ngModel)]="ato.observacao" *ngIf="visualizarObservacoes" [disabled]="readonly"></textarea>
            </div>
        </div>

        <ng-container *ngIf="!segmentosCarregados">
            <div id="areaConteudo" [class]="fullscreen ? 'tela-cheia' : 'tamanho-reduzido'">
                <div class="titulo-pagina" *ngIf="fullscreen">Incluir ato - conteúdo do ato</div>
                <label for="_conteudoAtoOriginal" class="control-label obrigatorio" *ngIf="!fullscreen">Conteúdo do ato</label>
                <div class="top-toolbox">
                    <button class="material-icons icon-18" style="float:right" (click)="fullscreen=true" *ngIf="!fullscreen">fullscreen</button>
                    <button class="material-icons icon-18" style="float:right" (click)="fullscreen=false" *ngIf="fullscreen">close_fullscreen</button>
                </div>
                <div id="divConteudo">
                    <textarea class="form-control" name="_conteudoAtoOriginal" rows="15" cols="100" *ngIf="!fullscreen"
                            [(ngModel)]="conteudoAtoOriginal"></textarea>
                    <textarea class="form-control" name="_conteudoAtoOriginal" class="tela-cheia" *ngIf="fullscreen"
                            [(ngModel)]="conteudoAtoOriginal"></textarea>
                </div>
                <ng-container *ngTemplateOutlet="containerAtosDuplicados"></ng-container>
                <ng-container *ngTemplateOutlet="botoes"></ng-container>
            </div>
        </ng-container>

        <ng-container *ngIf="segmentosCarregados">
            <div class="row">
                <div class="col-md-12">
                    <label class="control-label obrigatorio">Conteúdo do ato</label>
                    <app-editar-conteudo-ato
                        [assuntos]="assuntos"
                        [assuntoGlobal]="assunto"
                        [segmentos]="segmentosTela"
                        (salvar)="salvarAto()"
                        [fullscreen]="fullscreen"
                        [tituloPagina]="tipoEdicao.titulo"
                        [tiposSegmento]="tiposSegmento"
                        [readonly]="readonly">
                    </app-editar-conteudo-ato>
                </div>
            </div>
            <ng-container *ngTemplateOutlet="containerAtosDuplicados"></ng-container>
            <ng-container *ngTemplateOutlet="botoes"></ng-container>
        </ng-container>

        <ng-template #containerAtosDuplicados>
            <div class="row" *ngIf="atosDuplicados && atosDuplicados.length > 0" id="div-atos-duplicados">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                    <app-listar-atos-duplicados 
                        [atosDuplicados]='atosDuplicados'
                        [conteudoAto]="getConteudoComparacao()"
                        [idAtoCorrecao]="getIdAtoCorrecao()"
                        (prosseguir)="prosseguirDaComparacao()"
                        (republicarDaComparacao)="republicarDaComparacao($event)"
                        (converterPublicacaoRepetida)="converterPublicacaoRepetida($event)">
                    </app-listar-atos-duplicados>
                </div>
                <div class="col-md-1"></div>
            </div>
        </ng-template>

        <ng-template #botoes>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <button type="button" class="btn btn-primary" (click)="prosseguir()"
                            *ngIf="!tipoEdicao.isInclusaoAto() && !segmentosCarregados">Prosseguir</button>
                        <button type="button" class="btn btn-primary" (click)="prosseguir()"
                            *ngIf="tipoEdicao.isInclusaoAto() && !segmentosCarregados && (!atosDuplicados || atosDuplicados.length === 0)">Prosseguir</button>
                        <button type="submit" class="btn btn-primary" (click)="salvarAto()" 
                            *ngIf="segmentosCarregados">Salvar</button>
                        <button type="button" class="btn btn-default" (click)="limparFormulario()" 
                            *ngIf="!fullscreen && tipoEdicao.isInclusaoAto()">Limpar formulário</button>
                    </div>
                </div>
            </div>
        </ng-template>

    </form>
</ng-container>
